import confirmTemplate from './confirm.tpl.html';
import './confirm.less';
import { legalLinksComponentModule } from '../../components/legal-links/legal-links';
import { appConfig } from '../../constants/app-config';
import { uiRouterStateModule } from '../../vendor/ui-router-module';
import { accountServiceModule } from '../../services/account-service/account-service';
import { ensureLeadingSlash } from '../../utils/string-utils';

export const confirmRouteModule = angular
  .module('Q.routes.confirm', [
    uiRouterStateModule,
    accountServiceModule,
    legalLinksComponentModule,
  ])

  .config(function ($stateProvider) {
    $stateProvider.state('confirm', {
      url: '/confirm/:token',
      template: confirmTemplate,
      data: {
        pageTitle: 'Confirm Your Email',
        bodyClass: 'confirm-account',
      },
      resolve: {
        confirmation: /* @ngInject */ function ($stateParams, accountService) {
          return accountService.confirm($stateParams.token).catch((res) => res);
        },
      },
      controller: /* @ngInject */ function (
        $scope,
        confirmation,
        $window,
        $location,
      ) {
        if (confirmation.status) {
          $scope.confirmed = false;
          $scope.error =
            confirmation.status === 423
              ? 'This account is locked and cannot be confirmed.'
              : 'There was an issue confirming your email.';
        } else {
          $scope.confirmed = true;
        }

        $scope.go = function () {
          // force a reload
          $window.location.replace(
            $location
              .absUrl()
              .replace(
                $location.url(),
                ensureLeadingSlash(appConfig.defaultRouteUrl || '/'),
              ),
          );
        };
      },
    });
  });
